class UtilsFunctions {
    getTimeFormat(resolutionHours, durationHours) {
        if (resolutionHours <= 1) {
            // Hourly resolution
            if (durationHours <= 24) {
                // duration less then 24 hours
                return 'HH:mm';
            }
            return 'MMM DD, HH:mm';

        } else if (resolutionHours <= 28 * 24) {
            // Daily resolution
            if (durationHours <= 365 * 24) {
                // duration less then 1 year
                return 'MMM DD';
            }
            return 'MMM DD, YYYY';

        }
        // Monthly resolution
        if (durationHours <= 365 * 24) {
            // duration less then 1 year
            return 'MMM';
        }
        return 'MMM YYYY';
    }


    sortScanHistoryDates(firstDate, secondDate) {
        if (firstDate.start_time && !secondDate.start_time) {
            return 1;
        } else if (!firstDate.start_time && secondDate.start_time) {
            return -1;
        } else if (!firstDate.start_time && !secondDate.start_time) {
            return 0;
        }

        return firstDate.start_time.localeCompare(secondDate.start_time);
    }

    sortHelper(first, second) {
        if (first > second) {
            return 1;
        } else if (first < second) {
            return -1;
        }
        return 0;
    }

}


export default new UtilsFunctions();
